<template>
    <div class="Overall">
        <div class="header">
            <div>
                <div class="item">{{$t('original.languages581')}}：
                    <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="params.deptID"
                    filterable :options="optionsnew" :props="{ checkStrictly: true }" clearable></el-cascader>
                </div>
                <div class="item">{{$t('original.Select_scale')}}：
                    <el-cascader   v-model="params.paperCode"  :options="scalelist" clearable :props="{label:'PaperName',value:'PaperCode',children:'LiPaper',emitPath:false}" :show-all-levels="false" node-key="PaperCode" ref="tree" @change="handleChange">
                    </el-cascader>
                </div>
                <div class="item">{{$t('original.languages562')}}：
                    <el-date-picker v-model="testTime" type="daterange" :range-separator="$t('original.languages296')"  :start-placeholder="$t('original.languages38')" :end-placeholder="$t('original.languages39')" value-format="yyyy-MM-dd"  @change="handleTime">
                    </el-date-picker>
                </div>
            </div>

            <div>
                <div class="item">
                    {{$t('original.languages582')}}：
                    <el-select v-model="type" clearable>
                        <el-option :label="$t('original.languages493')" value="1"></el-option>
                        <el-option :label="$t('original.languages583')" value="2"></el-option>
                        <el-option :label="$t('original.languages584')" value="3"></el-option>
                        <el-option :label="$t('original.languages585')" value="4"></el-option>
                    </el-select>
                </div>
                <el-button type="primary" @click="search">{{$t('original.languages470')}}</el-button>
                <el-button @click="reset">{{$t('original.reset')}}</el-button>
            </div>
        </div>

        <div class="Content" v-infinite-scroll="load">

            <el-table  v-if="params.type == 1" :data="tallteststatistics.totalStatisticsList"  v-loading="loading"  style="width: 100%">
                <el-table-column prop="paperName" :label="$t('original.Name_of_scale')"></el-table-column>
                <el-table-column prop="totalTimes" :label="$t('original.languages586')"></el-table-column>
                <el-table-column prop="totalCount" :label="$t('original.languages587')"></el-table-column>
            </el-table>

            <el-table  v-else-if="params.type == 2"  :data="tallteststatistics.testTimesList"  v-loading="loading"  style="width: 100%">
                <el-table-column prop="paperName" :label="$t('original.Name_of_scale')"></el-table-column>
                <el-table-column prop="testResult" :label="$t('original.languages590')"></el-table-column>
                <el-table-column prop="times" :label="$t('original.languages586')"></el-table-column>
                <el-table-column prop="count" :label="$t('original.languages587')"></el-table-column>
            </el-table>

            <el-table v-else-if="params.type == 3" :data="tallteststatistics.warningDistributionList" v-loading="loading" style="width: 100%">
                <el-table-column prop="paperName" :label="$t('original.Name_of_scale')"></el-table-column>
                <el-table-column prop="warningResult" :label="$t('original.languages144')"></el-table-column>
                <el-table-column prop="warningSource" :label="$t('original.languages589')"></el-table-column>
                <el-table-column prop="count" :label="$t('original.languages587')"></el-table-column>
            </el-table>

            <el-table v-else-if="params.type == 4" :data="tallteststatistics.averageScoreRankingList" v-loading="loading" style="width: 100%">
                <el-table-column prop="paperName" :label="$t('original.Name_of_scale')"></el-table-column>
                <el-table-column prop="deptName" :label="$t('original.class_name')"></el-table-column>
                <el-table-column prop="avgScore" :label="$t('original.languages588')"></el-table-column>
                <el-table-column prop="rank" :label="$t('original.languages587')"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default{
    name:'Overall',
    data() {
        return {
            loading:false,
            tallteststatistics:[],
            testTime:this.Global.querycensus(6),
            optionsnew:[],
            scalelist:[],
            type:'1',
            isload:true,
            params:{
                pageIndex:1,
                pageSize:20,
                Total:0,
                deptID:'',
                paperCode:'',
                startTime:'',
                endTime:'',
                type:'1'//1-总体统计 2-测试次数3-预警分布4-班级平均分排名
            }
        }
    },
    created() {
        this.params.startTime = this.Global.querycensus(6)[0];
        this.params.endTime = this.Global.querycensus(6)[1];
        this.GetDeprtMentByNode();
        this.querypaper();
        this.getallteststatistics()
    },
    methods: {
        search(){
            this.params.type = this.type;
            this.params.pageIndex = 1;
            this.getallteststatistics();
        },
        // 获取所有量表
        querypaper(){
            this.$Http_Post('ScaleIssue/GetShowScale',{Tiaojian:''}).then(res=>{
                if(res.Code==200 || res.Code==0){
                    this.scalelist = res.Data;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        },
        // 获取部门列表
        GetDeprtMentByNode(){
            this.$Http_Post('DepartMent/GetDeprtMentByNode').then(res=>{
                if(res.Code == 0 || res.Code == 200){
                    this.optionsnew = res.Data;
                }
            })
        },
        getallteststatistics(){
            this.loading=true;
            this.$Http_Post('querypaper/getallteststatistics',this.params).then(res=>{
                this.loading=false
                if(res.Code==0){
                    if(this.params.pageIndex==1){
                        this.tallteststatistics=res.Data;
                    }else{
                        if(this.params.type == 1){
                            this.tallteststatistics.totalStatisticsList = this.tallteststatistics.totalStatisticsList.concat(res.Data.totalStatisticsList);
                        }else if(this.params.type == 2){
                            this.tallteststatistics.testTimesList = this.tallteststatistics.testTimesList.concat(res.Data.testTimesList);
                        }else if(this.params.type == 3){
                            this.tallteststatistics.warningDistributionList = this.tallteststatistics.warningDistributionList.concat(res.Data.warningDistributionList);
                        }else{
                            this.tallteststatistics.averageScoreRankingList = this.tallteststatistics.averageScoreRankingList.concat(res.Data.averageScoreRankingList);
                        }
                    }
                
                    this.params.Total=res.Counts;
                    this.isload=true;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        // 重置
        reset(){
            this.testTime=this.Global.querycensus(6);
            this.params={
                pageIndex:1,
                pageSize:20,
                Total:0,
                deptID:'',
                paperCode:'',
                startTime:this.Global.querycensus(6)[0],
                endTime:this.Global.querycensus(6)[1],
                type:'1'//1-总体统计 2-测试次数3-预警分布4-班级平均分排名
            }
            this.getallteststatistics();
        },
        // 选择发布对象
        bumen(dt) {
            let obj = this.optionsnew[0];
            for (let i = 0; i < this.optionsnew.length; i++) {
                if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
                    obj = this.optionsnew[i];
                    break;
                } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
                obj = this.GetNodeByDeptID(
                    dt[dt.length - 1],
                    this.optionsnew[i].children
                );
                }
            }

            let _this = this;
            if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
                obj.children = [{ label: this.$t('original.languages22') }];
                    this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:dt[dt.length-1],content:''}).then((res) => {
                    if (res.Code == 200 || res.Code == 0 && res.Data){
                        obj.children = res.Data;
                    }
                });
            }
        },
        GetNodeByDeptID(ID, NodeList) {
            let obj = null;
            for (let i = 0; i < NodeList.length; i++) {
                if (NodeList[i].DeptID == ID) {
                    obj = NodeList[i]
                    break
                } else if (
                    NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
                ) {
                    obj = this.GetNodeByDeptID(ID, NodeList[i].children);
                if (obj != null) break
                }
            }
            return obj
        },
        Selected_to_shut_dow(dt) {
            this.params.deptID = dt[dt.length - 1];
            this.$refs.wcascader.dropDownVisible = false;
        },

        // 选择量表
        handleChange(checkedNodeKeys){
            this.params.paperCode = checkedNodeKeys;
            this.$refs.tree.dropDownVisible = false;
        },
        handleTime(val){
            if(val == null){
                this.params.startTime = '';
                this.params.endTime = '';
            }else{
                this.params.startTime = val[0];
                this.params.endTime = val[1];
            }
        },
        load(){
            if(Math.ceil(this.params.Total/this.params.pageSize)>this.params.pageIndex && this.isload){
                this.isload = false;
                this.params.pageIndex += 1;
                this.getallteststatistics();
            }
            
        }
    },
}
</script>
<style scoped>
.Overall .header{background: #fff;padding: 20px 0 0;}
.Overall .header .item{display: inline-block;margin:0 30px 20px;}
.Overall .Content{margin-top: 20px;background: #fff;padding:20px;}
</style>